module.exports = __webpack_public_path__ + "static/media/ic_player_stop.0a864cac.svg";